import { useSelector } from 'react-redux'
import { intersectionBy } from 'lodash-es'
import { RootState } from '@/redux/store.ts'
import { AllHcRoles } from '@/common/types/auth.def.ts'
import { useGetOwnProfileQuery } from '@/features/user/user.api.ts'
import { useGetPermissionsQuery, useGetRolesQuery } from '@/features/auth/auth.api.ts'
import { ModuleFunction } from '@/features/auth/auth.def.ts'

export const useAuth = () => {
  const auth = useSelector((state: RootState) => state.auth)
  const token = auth.user?.token || ''
  const impersonatedUsername = auth.impersonatedUsername
  const isImpersonated = !!impersonatedUsername

  useGetPermissionsQuery(undefined, {
    skip: !token,
    pollingInterval: 300000, // 5 minutes
    skipPollingIfUnfocused: true,
  })
  useGetRolesQuery(undefined, {
    skip: !token,
    pollingInterval: 300000, // 5 minutes
    skipPollingIfUnfocused: true,
  })
  const { data: profile } = useGetOwnProfileQuery({}, {
    skip: !token,
    pollingInterval: 300000, // 5 minutes
    skipPollingIfUnfocused: true,
  })

  return {
    user: auth.user,
    userProfile: profile,
    isHc: AllHcRoles.some(role => auth.user?.roles.includes(role)),
    permissions: auth.permissions,
    checkHasAllPermissions: (requiredPermissions: ModuleFunction[] = []) => intersectionBy(
      requiredPermissions,
      auth.permissions || [],
      x => `${x.moduleName}:${x.functionName}`,
    ).length == requiredPermissions.length,
    checkHasAnyPermissions: (requiredPermissions: ModuleFunction[] = []) => intersectionBy(
      requiredPermissions,
      auth.permissions || [],
      x => `${x.moduleName}:${x.functionName}`,
    ).length > 0,
    impersonatedUsername,
    isImpersonated,
  }
}